import { render, staticRenderFns } from "./EditCouponRule.vue?vue&type=template&id=8a988f8e&scoped=true"
import script from "./EditCouponRule.vue?vue&type=script&lang=js"
export * from "./EditCouponRule.vue?vue&type=script&lang=js"
import style0 from "./EditCouponRule.vue?vue&type=style&index=0&id=8a988f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a988f8e",
  null
  
)

export default component.exports